<template>
  <div>
    <Teleport v-if="afetrTitleActionSpaceMounted" to="#page-title-action-space">
      <div class="d-flex align-items-center justify-content-end w-100">
        <div class="d-flex align-items-center">
          <BasicButton
            label="新規作成"
            class="add-btn me-2"
            variant="secondary"
            outlined
            icon="pi pi-plus"
            @click="
              goto({
                name: 'UsersSystemAdminTrainingsNew',
                query: { organizationId: selectedOrganizationId },
              })
            "
          />
        </div>
      </div>
    </Teleport>

    <Card class="mb-3">
      <template #content>
        <TrainingFilter
          v-model:selected-organization-id="selectedOrganizationId"
          v-model:selected-year="selectedYear"
          :organizations="organizations"
          :trainings-years="trainingsYears"
          viewmode
        />
      </template>
    </Card>

    <Card>
      <template #content>
        <div v-if="!trainings">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <div v-else-if="trainings.length">
          <TrainingTable
            :trainings="trainings"
            is-abc-t-manager
            @select-training="gotoShow"
            @edit-training="gotoEdit"
            @destroy-training="handleDestroy"
          />
        </div>
        <div v-else class="d-flex align-items-center">
          <span>研修が存在しません</span>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { useUser, useTrainings, useRouterUtil } from "/@/vue/composables";
import { BasicButton, Label as FormLabel } from "/@/vue/components/Atom";
import { Table as TrainingTable } from "/@/vue/components/Organisms/Users/Trainings";
import { Filter as TrainingFilter } from "/@/vue/components/Molecules/Trainings";
import { computed, inject, ref, watch } from "vue";
import Card from "primevue/card";
import { getStorage, setStorage } from "/@/modules/localStorage";

const afetrTitleActionSpaceMounted = inject("afetrTitleActionSpaceMounted");

const { goto } = useRouterUtil();

const { getUser } = useUser();
const { data: user } = getUser();

const organizations = computed(() => {
  if (!user.value) return [];

  return user.value.managedOrganizations;
});

const selectedOrganizationId = ref(
  getStorage("selectedOrganizationId") || undefined
);

watch(selectedOrganizationId, (id) => {
  if (!id) return;
  setStorage("selectedOrganizationId", id);
});

const selectedYear = ref(getStorage("selectedYear") || "all");
watch(selectedYear, (year) => {
  if (!year) return;

  setStorage("selectedYear", year);
});

const trainingsYears = computed(() => {
  if (!trainings.value) return [];

  return [
    "all",
    ...Array.from(new Set(trainings.value.map((n) => n.createdAt.slice(0, 4)))),
  ];
});

watch(organizations, (os) => {
  if (!os || !os.length) return;

  if (!selectedOrganizationId.value) {
    selectedOrganizationId.value = os[0]?.id;
  }
});

const { getSystemAdminTrainings, destroyTraining } = useTrainings();
const { data: trainings, mutate: getFormatsMutate } = getSystemAdminTrainings(
  selectedOrganizationId
);

function gotoShow(id: number) {
  goto({
    name: "UsersSystemAdminTrainingsShow",
    params: {
      id,
    },
  });
}

function gotoEdit(id: number) {
  goto({ name: "UsersSystemAdminTrainingsEdit", params: { id: id } });
}

async function handleDestroy(id: number) {
  if (!window.confirm("本当に削除しますか？この操作は取り消せません。")) {
    return;
  }

  if (await destroyTraining(id)) {
    alert("削除しました");
    getFormatsMutate();
  } else {
    alert("削除に失敗しました");
  }
}
</script>

<style scoped></style>
